import { render, staticRenderFns } from "./IconDespacho.vue?vue&type=template&id=4c50cba2"
import script from "./IconDespacho.vue?vue&type=script&lang=js"
export * from "./IconDespacho.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports